import { render, staticRenderFns } from "./KelompokWakaf.vue?vue&type=template&id=2481e99a"
import script from "./KelompokWakaf.vue?vue&type=script&lang=js"
export * from "./KelompokWakaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports